module.exports = __webpack_public_path__ + "static/media/bg.42f4bdfc.png";